import PropTypes from 'prop-types';
import React from 'react';
import getData from './getData';

/**
 *  Creates a standard AutoDealer schema
 *
 */
function AutoDealer(_ref) {
  let {
    owner,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("script", Object.assign({
    "data-cmp": "dealerSchema",
    type: "application/ld+json"
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: `${JSON.stringify(getData(owner))}`
    }
  }, rest));
}
export default AutoDealer;